import React, {useContext, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import FilterDropdown, {FILTER_SELECT_STYLES} from "../FilterDropdown.jsx";
import Select from "react-select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faListOl, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import Badge from "../Badge.jsx";
import {FilterContext} from "./DashboardFilterContextProvider.jsx";
import {campaignChartDisplayLabels, campaignChartIdentity, campaignIsSelectedByFilter} from "../../pages/dashboard/OrderDashboard/TablesAndGraphs/ByFilter/campaignChartPresentation.js";

function CampaignFilter() {
    let {t} = useTranslation();

    let {
        campaignsPossible,
        campaignsAllowListed, setCampaignsAllowListed,
        campaignSearchFilter, setCampaignSearchFilter,

        sourcesRemoved,
    } = useContext(FilterContext);

    let [selectOpened, setSelectOpened] = useState(false);
    let registeredCampaigns = useMemo(() => Object.values(campaignsPossible), [campaignsPossible]);
    let visibleCampaigns = useMemo(() => registeredCampaigns.filter((campaign) => !sourcesRemoved.includes(campaign.integrationName)), [registeredCampaigns, sourcesRemoved]);
    let campaignLabels = useMemo(() => campaignChartDisplayLabels(visibleCampaigns), [visibleCampaigns]);

    let defaultOptions = useMemo(() => {
        let defaultOptions = [];

        visibleCampaigns.map((possibleValue) => {
            if (campaignIsSelectedByFilter(possibleValue, campaignsAllowListed, registeredCampaigns)) {
                defaultOptions.push({
                    value: possibleValue.remoteId,
                    label: campaignLabels.get(campaignChartIdentity(possibleValue)) ?? possibleValue.name ?? possibleValue.campaignName ?? '-',
                    campaign: possibleValue
                });
            }
        });

        return defaultOptions;
    }, [visibleCampaigns, campaignsAllowListed, campaignSearchFilter, registeredCampaigns, campaignLabels]);

    let possibleAmount = useMemo(() => {
        let possibleAmount = 0;

        visibleCampaigns.forEach(() => { possibleAmount++; });

        return possibleAmount;
    }, [visibleCampaigns, campaignsAllowListed, campaignSearchFilter]);

    let options = useMemo(
        () => {
            return visibleCampaigns.map((possibleValue) => {
                    return {
                        value: possibleValue.remoteId,
                        label: campaignLabels.get(campaignChartIdentity(possibleValue)) ?? possibleValue.name ?? possibleValue.campaignName ?? '-',
                        campaign: possibleValue
                    };
                });
        },
        [visibleCampaigns, campaignsAllowListed, campaignSearchFilter, campaignLabels],
    );


    // noinspection JSUnresolvedReference,JSValidateTypes
    return (<FilterDropdown
        title={t('filter.campaigns')}
        align={'right'}
        button={<div className={'flex justify-center items-center text-nowrap gap-1'}>
            <FontAwesomeIcon icon={faListOl}/>
            {t('filter.campaigns')}

            {campaignSearchFilter.trim() !== '' && <Badge color={'slate'} className={'flex gap-1'}>
                <FontAwesomeIcon icon={faMagnifyingGlass}/>
                {campaignSearchFilter}
            </Badge>}

            {defaultOptions.length > 0 && <Badge color={'slate'}>
                {defaultOptions.length} / {possibleAmount}
            </Badge>}

        </div>}
        inhibitClosing={selectOpened}
    >
        <div className={'min-w-96'}>
            <input
                value={campaignSearchFilter}
                className={'form-input w-full mb-2'}
                onChange={event => setCampaignSearchFilter(event.target.value)}
            />

            <Select
                isMulti
                options={options}
                value={defaultOptions}
                menuPortalTarget={document.body}
                menuPosition='fixed'
                styles={FILTER_SELECT_STYLES}
                noOptionsMessage={() => t('filter.no-campaigns-found')}
                onMenuOpen={() => setSelectOpened(true)}
                onMenuClose={() => setTimeout(() => setSelectOpened(false), 100)}
                onChange={(val) => setCampaignsAllowListed(val.map((obj) => obj.value))}
                className={'datixo_select_container'}
                classNamePrefix={'datixo_select'}
            />
        </div>
    </FilterDropdown>);
}

export default CampaignFilter;
